module.exports = __webpack_public_path__ + "static/media/lifeline_step_7.f8e81bbe.png";